import {useMemo} from 'react';
import type {BreadcrumbItem} from 'src/app/layout/BackBar';
import {PathUtility} from 'src/shared/constants/PathBuilder';

export type NotificationRulesBreadcrumbMode = 'view' | 'create' | 'edit';

export interface UseNotificationRulesBreadcrumbsProps {
  mode: NotificationRulesBreadcrumbMode;
  ruleId?: number | string;
  ruleName?: string;
}

export interface UseNotificationRulesBreadcrumbsResult {
  breadcrumbs: BreadcrumbItem[];
  fallbackTo: string;
}

export const useNotificationRulesBreadcrumbs = ({
  mode,
  ruleId,
  ruleName,
}: UseNotificationRulesBreadcrumbsProps): UseNotificationRulesBreadcrumbsResult => {
  return useMemo(() => {
    const crumbs: BreadcrumbItem[] = [
      {label: 'Notification Rules', to: PathUtility.NotificationRule()},
    ];

    let fallbackTo = PathUtility.NotificationRule();

    switch (mode) {
      case 'create': {
        crumbs.push({label: 'New'});
        break;
      }

      case 'edit': {
        crumbs.push({
          label: ruleName || 'Rule',
          to: PathUtility.NotificationRuleView(String(ruleId)),
        });
        crumbs.push({label: 'Edit'});
        fallbackTo = PathUtility.NotificationRuleView(String(ruleId));
        break;
      }

      case 'view': {
        crumbs.push({label: ruleName || 'View'});
        break;
      }
    }

    return {breadcrumbs: crumbs, fallbackTo};
  }, [mode, ruleId, ruleName]);
};
